<template>
  <van-tree-select
    :items="items"
    :active-id.sync="activeId"
    :main-active-index.sync="activeIndex"
  />
</template>

<script>
import { getProductList } from '@/api/product'
export default {
  name: 'Test',
  data() {
    return {
      loading: false,
      data: [],
      items: [
        {
          text: '浙江',
          children: [{
            id: 1,
            text: '杭州'
          }, {
            id: 2,
            text: '温州'
          }]
        },
        {
          text: '江苏',
          children: [{
            id: 3,
            text: '南京'
          }]
        }
      ],
      activeId: 1,
      activeIndex: 0,
      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'ord',
        order: 'asc',
        status: this.CONST.STATUS.find(status => status.name === '启用').id
      }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.loading = true
      getProductList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test.vue